import styles from "./Spinner.module.scss";

interface SpinnerProps {
  size?: "small" | "large" | string;
}

const Spinner = ({ size }: SpinnerProps) => {
  const sizeClass = size === "large"
    ? styles.large_spinner
    : size === "small"
    ? styles.small_spinner
    : "";

  return (
    <div className={`${styles.spinner_component} ${sizeClass}`}>
      <div className={styles.custom_spinner}>
        <div className={styles.inner_circle}></div>
        <div className={styles.rotating_border}></div>
      </div>
    </div>
  );
};

export default Spinner;
